export enum RouteType {
  "FTL" = "FTL",
  "FTL2" = "FTL2",
  "Trunk" = "Trunk",
  "Top-Up" = "Top-Up",
  "ST-Return" = "ST-Return",
}
